// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import CreditNote from "./CreditNote";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Services
import { get } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
// Utils
import { CREDIT_NOTE_TABLE_HEADS } from "./CreditNote.utils";
import Filter from "./Filter";

const CreditNotes = () => {
  const permissions = usePermissions();
  const spinService = SpinService();
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(undefined);
  const [openFilter, setOpenFilter] = useState(false);
  const [filter, setFilter] = useState({
    sort: "id",
    order: "desc",
    max: 10,
    offset: 0,
    search: "",
    queryFilters: "{}",
  });

  const [creditNotes, setCreditNotes] = useState({
    entries: [],
    total_count: 0,
  });

  const onClose = () => {
    setId(undefined);
    setOpen(false);
    setOpenFilter(false);
  };

  useEffect(() => {
    const fetchCreditNotes = async () => {
      spinService.on();
      const response = await get(
        EntityConstants.CREDIT_NOTES,
        `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${
          filter.offset + 1
        }&search=${filter.search}&queryFilters=${filter.queryFilters}`
      );
      const data = await response.json();
      setCreditNotes(data);
      spinService.off();
    };
    !open && !openFilter && fetchCreditNotes();
  }, [
    filter.sort,
    filter.order,
    filter.max,
    filter.offset,
    filter.search,
    filter.queryFilters,
    open,
    openFilter,
  ]);

  return (
    <React.Fragment>
      <Container maxWidth={false}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
        >
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Credit Notes
          </Typography>
          {permissions.has(PermissionConstants.CREDIT_NOTE_CREATE) && (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => {
                setOpen(true);
              }}
            >
              New Credit Note
            </Button>
          )}
        </Stack>
        <Card>
          <GoTable
            tableHeads={CREDIT_NOTE_TABLE_HEADS}
            tableDatas={creditNotes.entries}
            totalCount={creditNotes.total_count}
            filter={filter}
            onFilter={(filter) =>
              setFilter((prevState) => {
                return {
                  ...prevState,
                  sort: filter.sort,
                  order: filter.order,
                  max: filter.max,
                  offset: filter.offset,
                  search: filter.search,
                };
              })
            }
            onView={(row) => {
              setId(row.id);
              setOpen(true);
            }}
            openFilter={() => setOpenFilter(true)}
            customFilter={true}
          />
        </Card>
      </Container>

      {permissions.has(PermissionConstants.CREDIT_NOTE_VIEW) && open && (
        <GoDrawer
          minwidth="50%"
          title="Credit Note"
          open={open}
          onClose={() => onClose()}
        >
          <CreditNote id={id} onClose={() => onClose()} />
        </GoDrawer>
      )}
      {openFilter && (
        <Filter
          queryFilters={filter.queryFilters}
          openFilter={openFilter}
          onClose={() => onClose()}
          onFilters={(filterQuries) =>
            setFilter((prevState) => {
              return {
                ...prevState,
                queryFilters: JSON.stringify(filterQuries),
              };
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default CreditNotes;
